import { Color } from "utils/theme";

interface ToggleProps {
  enabled: boolean;
  setEnabled: (value: boolean) => void;
  size?: "sm" | "md" | "lg";
  disabled?: boolean;
  /** Distinguishes this toggle from the others in the analytics press counts */
  name?: string;
}

export default function Toggle({
  enabled,
  setEnabled,
  size = "lg",
  disabled = false,
  name,
}: ToggleProps) {
  const analyticsName = name ? `toggle.${name}` : undefined;
  if (size === "sm") {
    return (
      <button
        aria-label="toggle-button"
        data-analytics={analyticsName}
        onClick={() => !disabled && setEnabled(!enabled)}
        className={`
          relative inline-flex items-center p-0.5 h-5 w-9 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75`}
        style={{ background: enabled ? Color.Indigo[500] : Color.Primary[600] }}
        disabled={disabled}
      >
        <span
          aria-hidden="true"
          className={`${enabled ? "translate-x-4" : "translate-x-0"}
            pointer-events-none inline-block size-3.5 transform rounded-full shadow-lg ring-0 transition duration-200 ease-in-out`}
          style={{ background: Color.White }}
        />
      </button>
    );
  }

  if (size === "md") {
    return (
      <button
        aria-label="toggle-button"
        data-analytics={analyticsName}
        onClick={() => !disabled && setEnabled(!enabled)}
        className={`
          relative inline-flex items-center p-0.5 h-7 w-12 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75`}
        style={{ background: enabled ? Color.Indigo[500] : Color.Primary[600] }}
        disabled={disabled}
      >
        <span
          aria-hidden="true"
          className={`${enabled ? "translate-x-5" : "translate-x-0"}
            pointer-events-none inline-block size-5 transform rounded-full shadow-lg ring-0 transition duration-200 ease-in-out`}
          style={{ background: Color.White }}
        />
      </button>
    );
  }

  return (
    <button
      aria-label="toggle-button"
      data-analytics={analyticsName}
      onClick={() => !disabled && setEnabled(!enabled)}
      className={`
          relative inline-flex items-center p-1 h-10 w-[4.5rem] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75`}
      style={{
        background: enabled ? Color.Indigo[500] : Color.Primary[600],
      }}
      disabled={disabled}
    >
      <span
        aria-hidden="true"
        className={`${enabled ? "translate-x-7" : "translate-x-0"}
            pointer-events-none inline-block w-8 h-8 transform rounded-full shadow-lg ring-0 transition duration-200 ease-in-out`}
        style={{ background: Color.White }}
      />
    </button>
  );
}
